import { render, staticRenderFns } from "./SfCharacteristic.vue?vue&type=template&id=7e3e91ec&"
import script from "./SfCharacteristic.vue?vue&type=script&lang=js&"
export * from "./SfCharacteristic.vue?vue&type=script&lang=js&"
import style0 from "./SfCharacteristic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports